module.exports = __webpack_public_path__ + "media/images/icon__delete--rb-orange@2x-f2aad7360c6480d196becc9faec160e9.png";